import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { columns } from "./table-config";

export function IncomingInvoicePositions({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice, isLoading, queryKey, refetch } = useIncomingInvoice(incomingInvoiceId);

	/** Render */
	return (
		<DataTable
			data={incomingInvoice?.positions ?? []}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
			persistenceKey="incoming-invoice-positions-table"
		/>
	);
}
